import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/infra/supabase/client";
import {
  AccessStatus,
  computeAccessStatus,
} from "@/data/admin/userAccess.service";

async function fetchOwnAccessStatus(): Promise<AccessStatus | null> {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) return null;
  const { data, error } = await supabase
    .from("profiles")
    .select("expires_at, is_admin")
    .eq("id", user.id)
    .maybeSingle();
  if (error || !data) return null;
  const expiresAt = data.expires_at ? new Date(data.expires_at) : null;
  return computeAccessStatus(expiresAt, !!data.is_admin);
}

export function useExpirationStatus() {
  return useQuery<AccessStatus | null>({
    queryKey: ["ownAccessStatus"],
    queryFn: fetchOwnAccessStatus,
    staleTime: 5 * 60 * 1000,
  });
}
